// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chipHeight[data-v-29717235] {\n  height: 54px;\n}\n.circleWidth[data-v-29717235] {\n  width: 54px;\n  height: 54px;\n}\n.maxChipWidth[data-v-29717235] {\n  max-width: 12rem;\n}\n.initialColorReview[data-v-29717235] {\n  color: white !important;\n}\n.customMargin[data-v-29717235]{\n  margin-left: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
